// extracted by mini-css-extract-plugin
export var button = "Contact-module--button--3HbJS";
export var container = "Contact-module--container--oIdK2";
export var titlesContainer = "Contact-module--titlesContainer--3Ed18";
export var buttonWrap = "Contact-module--buttonWrap--xxZsV";